import { Asset } from "./asset";
import { PropertyType } from "./property-type";

export class AssetProperty {
  name: string;
  value: string;
  timestamp: number;
  asset: Asset;
  propertyType: PropertyType;
  uuid: string;
}
